import _ from 'lodash';

export function spliceOut(array, item) {
	const idx = array.indexOf(item);
	if (idx > -1) {
		array.splice(idx, 1);
	}
}

export function spliceOutWhere(array, item) {
	const idx = _.findIndex(array, item);
	if (idx > -1) {
		array.splice(idx, 1);
	}
}
